import htmlToElement from 'html-to-element';


const supernavs = document.querySelectorAll('[data-supernav]');
const mainnav = document.querySelector('[data-nav="main"]');
const locale = mainnav.dataset.navLocale;
const supernavCache = {};

const updateSupersub = (el, data) => {
    el.textContent = '';
    const subEl = htmlToElement(data);
    el.append(subEl);
};

const updateNavPromo = (submenu, id) => {
    const pane = submenu.closest('.Navigation__pane');
    const promoEl = pane.querySelector('.Navigation__promo');
    let navPromo = null;
    const navLink = document.querySelector(`[data-nav-id="${id}"][data-nav-promo]`);
    if (navLink) {
        const navString = navLink.dataset.navPromo.trim();
        if (navString.length) {
            navPromo = htmlToElement(navString);
        }
    }

    if (navPromo) {
        pane.classList.add('-hasPromo');
        if (promoEl) {
            promoEl.replaceWith(navPromo);
        }
        submenu.after(navPromo);
    } else {
        pane.classList.remove('-hasPromo');
        if (promoEl) {
            promoEl.remove();
        }
    }

};

const updateSubmenu = (submenu, currentId) => {
    Array.from(submenu.children).forEach((item) => {
        const link = item.querySelector('a');
        const id = parseInt(link.dataset.navId);
        if (id === parseInt(currentId)) {
            link.classList.add('-section');
        } else {
            link.classList.remove('-section');
        }
    });
};

// do this at start
const setupSupernav = (supernav, supersub, submenu, id) => {
    supernav.classList.add('-supernav');
    submenu.classList.add('-supernav');
    submenu.after(supersub);
    updateSupernav(supersub, submenu, id, locale);
    // markSectionCurrent();
};

const updateSupernav = (supersub, submenu, id) => {
    supersub.classList.add('Loading');
    const pane = submenu.closest('.Navigation__pane');
    fetchNav(id)
        .then((data) => {
            if (data) {
                updateSubmenu(submenu, id);
                updateSupersub(supersub, data);
                updateNavPromo(submenu, id);
                supersub.classList.remove('Loading');
                // force layout / reflow
                pane.style.height = '100px';
                setTimeout(() => {
                    pane.style.height = 'auto';
                }, 1);
            }
        });
};

const fetchNav = (id) => {
    const cachekey = encodeURIComponent(mainnav.dataset.navCachekey);
    const fetchURL = `/nav/supersub/${id}/${locale}.json?m=${cachekey}`;
    if (supernavCache[fetchURL]) {
        return new Promise(function(resolve) {
            resolve(supernavCache[fetchURL]);
        });
    }
    return fetch(fetchURL)
        .then(r => r.json())
        .then((data) => {
            supernavCache[fetchURL] = data;
            return data;
        })
        .catch(() => {
            return null;
        });
};

supernavs.forEach((supernav) => {
    const submenu = supernav.querySelector('[data-supernav-submenus]');
    const supersub = htmlToElement('<div class="Navigation__supersub"></div>');
    const subitems = Array.from(submenu.children);
    let id = parseInt(supernav.dataset.supernav);

    // // figure out what to fetch adn display first
    // const path = document.location.pathname;
    // const current = Array.from(subitems).find((item) => {
    //     const link = item.querySelector('a');
    //     const loc = new URL(link.href).pathname;
    //     if (path.startsWith(loc)) {
    //         return link;
    //     }
    // });
    // if (current) {
    //     id = current.querySelector('a').dataset.navId;
    // }


    setupSupernav(supernav, supersub, submenu, id, locale);
    Array.from(subitems).forEach((item) => {
        const link = item.querySelector('a');
        const menuId = parseInt(link.dataset.navId);
        if (menuId) {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                // console.log({menuId, item});
                updateSupernav(supersub, submenu, menuId);
            });
        }
    });
});
